import { useState, useEffect } from 'react';


/**
 * Gets the element size.
 * @param {object} ref A react ref to an element.
 * @return [width, height] The width and height of the element.
 */
export default function useElementSize(element) {
  const [size, setSize] = useState([undefined, undefined]);

  useEffect(() => {
    if (!element) return () => {}; // No element. Don't bother adding/removing window scroll handlers.

    const handleResize = () => {
      setSize([element && element.offsetWidth, element && element.offsetHeight]);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    // On component unmount.
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [element, setSize]);

  return size; // [width, height]
}
